import { documentationActions } from '../../actions/constant';
const { PULL_UUID_SUCCESS, PULL_UUID_FAILURE, PULL_UUID_RESET, PULL_UUID_REQUEST } =
  documentationActions;
const intitialstate: object = {
  response: null,
  isgetUuid: false,
  loading: false,
};

export const pullUuidRducder = (state = intitialstate, action: any) => {
  switch (action.type) {
    case PULL_UUID_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case PULL_UUID_SUCCESS: {
      return {
        ...state,
        isgetUuid: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case PULL_UUID_FAILURE:
      return {
        ...state,
        isgetUuid: false,
        response: action.payload,
        loading: false,
      };

    case PULL_UUID_RESET:
      return intitialstate;

    default:
      return state;
  }
};
